import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ReportsService } from '../../../data/reports.service';
import { LineChartQuery } from '../../../data/line-chart.query';
import { LineChartStore } from '../../../data/line-chart.store';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DatePeriod } from 'projects/app-misc/src/app/modules/reports/view/graphs-view/graphs-view.component';
import { User } from 'projects/core/src/lib/login/data/user';
import moment from 'moment';
import { LocalStorage } from 'ngx-webstorage';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { SaleStat } from '../../../data/sale-stat';
import { Dataset, GraphData } from '../../../data/graph-data';


@Component({
  selector: 'app-dougnuts-view',
  templateUrl: './dougnuts-view.component.html',
  styleUrls: ['./dougnuts-view.component.scss']
})
@RxJSUnsubscribe
export class DougnutsViewComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  localSubj$ = new Subject<void>();

  graph: SaleStat[];

  datePeriod: DatePeriod;

  selectedUsers: User[];
  userMap = new Map<string, User>();

  basicDatas: GraphData[] = [];

  basicOptions: any[] = [];

  format = 'MMMM YYYY';

  tempUserMap = new Map();

  params = [
    {
      value: 'totalAmt',
      label: 'Estimates'
    },
    {
      value: 'invoicedBalance',
      label: 'Invoiced'
    },
    {
      value: 'paymentsReceived',
      label: 'Payments Recieved'
    },
    {
      value: 'unBilledAmount',
      label: 'Unbilled amount'
    }
  ]

  @LocalStorage()
  hiddenUsersIds: number[]

  chartCounter = 0;

  eventsArrsSubj: Subscription;
  datePeriodSubj: Subscription;
  selectedUsersSubj: Subscription;

  constructor(
    protected reportsService: ReportsService,
    protected lineChartQuery: LineChartQuery,
    protected lineChartStore: LineChartStore
  ) {
  }


  ngOnInit(): void {

    this.localSubj$.pipe(
      takeUntil(this.getUnsubFromAllSubs()),
      debounceTime(500)
    ).subscribe(emit => {
      this.fillDates()
    })

    this.serviceSub();

  }

  serviceSub() {
    this.eventsArrsSubj = this.lineChartQuery.events$.subscribe(data => {
      this.graph = [...data]

      if(this.graph) {
        // Delete Acadia total report
        this.graph.pop()
      }


      if(!this.localSubj$.closed) {
        this.localSubj$.next();
      }
    })

    this.datePeriodSubj = this.lineChartQuery.datePeriod$.subscribe(data => {
      this.datePeriod = data
    })

    this.selectedUsersSubj = this.lineChartQuery.selectedUsers$.subscribe(data => {
      this.userMap = new Map();

      this.selectedUsers = data

      this.selectedUsers.forEach(user => {
        this.userMap.set(user.name, user)
      })
    })
  }

  fillDates() {
    this.basicDatas = []
    this.basicOptions = []

    this.countUsersReport();

    this.updateInfo()

    this.lineChartStore.updateLoading(false);
  }

  countUsersReport() {
    if(this.graph) {
      this.params.forEach(param => {
        const basicData: GraphData = {
          labels: [],
          datasets: []
        };

        const usersMap = new Map();
        const dataSet: Dataset = {
          data: [],
          backgroundColor: [],
          hoverBackgroundColor: [],
          userId: []
        }

        this.graph.forEach(stat => {
          usersMap.set(stat.salesUser.name, stat[param.value])
        })

        usersMap.forEach((value: number, key: string) => {
          if(this.userMap.has(key)) {
            const userFromMap = this.userMap.get(key);

            basicData.labels.push(key)
            dataSet.data.push(Math.floor(value))
            dataSet.backgroundColor.push('#' + userFromMap.bgColor)
            dataSet.hoverBackgroundColor.push(this.hexToRgbA('#' + this.userMap.get(key).bgColor))
            dataSet.userId.push(userFromMap.id)
          }
        })

        basicData.datasets.push(dataSet)

        this.basicDatas.push(basicData)

        const basicOption = {
          plugins: {
            title: {
              display: true,
              text: param.label,
              fontSize: 16,
              position: 'bottom'
            },
            legend: {
              display: false
            },
            datalabels: {
              color: 'white',
              labels: {
                title: {
                  font: {
                    weight: 'bold',
                    size: '10px'
                  }
                }
              },
              textAlign: 'center',
              formatter: (value: number, context) => {
                let returnValue = this.numberWithCommas(value)

                if(context.dataIndex >= 0 && context.dataset) {
                  const userId = (context.dataset as Dataset).userId[context.dataIndex]
                  const fUser = this.selectedUsers.find(user => user.id === userId)
                  const totalSum = context.dataset.data.reduce((partialSum, a) => partialSum + a, 0);

                  if(fUser) {
                    returnValue += `\n (${fUser.shortCode} ${((value / totalSum) * 100).toFixed(2)}%)`
                  }
                }

                return value > 0 ? returnValue : null
              }
            }
          }
        }

        this.basicOptions.push(basicOption)
      })
    }
  }

  numberWithCommas(x) {
    return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  hexToRgbA(hex: string) {
    let c: any;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if(c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      // tslint:disable-next-line: no-bitwise
      const result = 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.9)'
      return result;
    }
    throw new Error('Bad Hex');
  }

  onOutletLoaded(component) {

  }

  updateInfo() {
    if(this.hiddenUsersIds) {
      this.hiddenUsersIds.forEach(id => {
        this.reportsService.userFilter$.next(id)
      })
    }
  }

  chartLoaded(event) {
    this.chartCounter++;
    if(this.chartCounter === this.basicDatas.length) {
      this.updateInfo()
    }
  }

  ngOnDestroy() {
    this.localSubj$.unsubscribe();
    this.eventsArrsSubj.unsubscribe();
    this.datePeriodSubj.unsubscribe();
    this.selectedUsersSubj.unsubscribe();
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
